<template>
	<div>
		asd
		<ol class="breadcrumb float-xl-end">
			<li class="breadcrumb-item active">Home</li>
		</ol>
		<h1 class="page-header"><i class="fab fa-delicious"></i> Home <small></small></h1>
		
	</div>
</template>

<script>	
	export default {
		data() {
			return {
			}
		},
		computed:{
			user(){
				return this.$store.state.user;
			},
		},
		created() {
			
		},
		methods: {
		}
	};
</script>